// home Product Slider

console.log('Design & Developed Theme by OneOnic Solutions. Version 1.0 http://oneonic.com/');

$( document ).ready( function() {
  if (window.matchMedia("(max-width: 768px)").matches) {
    setTimeout(function() {
      $( document ).find( '#insta-feed' ).find('#4-insta-feed').prev().hide();
      $( document ).find( '#insta-feed' ).find('#5-insta-feed').prev().hide();
    }, 6000);
  }

  $(window).on('resize', function(){
    var win = $(this); //this = window
    if (win.width() > 768 ) {
      $( document ).find( '#insta-feed' ).find('#4-insta-feed').prev().show();
      $( document ).find( '#insta-feed' ).find('#5-insta-feed').prev().show();
    } else {
      $( document ).find( '#insta-feed' ).find('#4-insta-feed').prev().hide();
      $( document ).find( '#insta-feed' ).find('#5-insta-feed').prev().hide();
    }
  } );


} );

if (window.matchMedia("(max-width: 768px)").matches) {
  /* the viewport is less than 768 pixels wide */
  $('.customproduct_slickslider').slick({
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
  });

} 

